import FileReports from '../../../reports/membership/FileReports';

const MembershipRetentionChart = ({ metric }) => <FileReports />;

export default MembershipRetentionChart;
